/* eslint-disable react/display-name */
// react
import React from 'react'

// css
import '../../css/components/SearchListView.styl'

//depedencies
import { Pagination } from '@st-operations/uikit/src/v2/index.js'
import { Table, Button, BUTTON_THEME } from '@st-operations/uikit/src/v2/index.js'
import TaxonomyBadge from './TaxonomyBadge.jsx'
import User from '../lib/User.js'
import ItemInfoCell from '_components/item-info-cell/index.jsx'

// libraries
import format from '@st-operations/uikit/lib/format.js'
import getAudienceSize from '../lib/getAudienceSize.js'

// constants
const TEAM_ID = require('../constants/sharethis_team_id.js')

const getTableColumns = (hasTaxonomy) => [
  {
    key: 'name',
    name: 'Audience Name',
    width: 480,
    render: (item) => <ItemInfoCell key={`item-${item.index}`} item={item} />,
    sortable: true,
  },
  hasTaxonomy
    ? {
        key: 'taxonomy.name',
        name: 'Taxonomy',
        render: (item) => <TaxonomyBadge key={`taxonomy-${item.index}`} taxonomy={item.taxonomy} />,
        className: 'center',
      }
    : {
        key: 'actual_size',
        name: 'Size',
        render: (item) => format('metric', getAudienceSize(item)),
        sortable: true,
        className: 'center',
      },
  hasTaxonomy
    ? {
        key: 'actual_size',
        name: 'Size',
        render: (item) => format('metric', getAudienceSize(item)),
        sortable: true,
        className: 'center',
      }
    : {
        key: 'created_by',
        name: 'Created by',
        render: (item) => item.created_by && item.created_by.email,
        className: 'center',
      },
  {
    format: 'date',
    key: 'updated_at',
    name: 'Last Updated',
    sortable: true,
  },
]

const OPTION_NAMES = {
  CUSTOM: 'custom',
  BRANDED: 'branded',
  WHITE_LABEL: 'white_label',
}

// component
class SearchListView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      sortDir: -1,
      sortKey: 'updated_at',
    }
  }

  componentDidMount() {
    User.watch(this, (user) => {
      if (user) {
        this.setState({ email: user.email, permissions: user.acl[TEAM_ID] })
      }
    })
  }

  onRowClick = (item) => {
    this.props.history.push(item.href)
  }

  onSort = (key) => {
    let { sortDir } = this.state
    let { sortAudience } = this.props
    if (key === this.state.sortKey) {
      this.setState({ sortDir: sortDir * -1 }, sortAudience(key, sortDir * -1))
    } else {
      this.setState({ sortKey: key, sortDir: 1 }, sortAudience(key, sortDir))
    }
  }

  sendReport = () => {
    const { query } = this.props
    const { email } = this.state
    window._api.post('/send-error-report', { email: email || '', query }, (err) => {
      if (err) {
        toast.error('Error sending report')
      } else {
        toast('Report successfully sent!')
      }
    })
  }

  render() {
    let { audienceGroups, audienceObj, currAudienceGroup, selected } = this.props
    let { changeSegments, onPageChange, page, query } = this.props
    let { permissions } = this.state

    // show all audiences in mobile view
    if (window.innerWidth < 800) {
      currAudienceGroup = audienceObj['all']
    }

    return (
      <div className="search-list">
        <div className="search-list__results">
          <span className="search-list__title">
            {`
            Found ${audienceObj[selected].length} ${selected.split('_').join(' ')}
            audience results for
            `}
            &nbsp;
            <b>{`'${query}'`}</b>
          </span>
          <If condition={audienceObj[selected].length > 0}>
            <Pagination options={audienceGroups} onPageChange={onPageChange} page={page} />
          </If>
        </div>

        <If condition={audienceObj['all'] && audienceObj['all'].length === 0}>
          <h2>{`That's a miss!`}</h2>
          <div>Sorry, try searching something else.</div>
          <Button ghost onClick={this.sendReport} style={{ width: '250px' }}>
            Send a report if you think this is an error.
          </Button>
        </If>

        <If condition={permissions && audienceObj['all'] && audienceObj['all'].length > 0}>
          <If condition={window.innerWidth > 800}>
            <div className="search-list__buttons">
              <If condition={permissions['Audience Creator']}>
                <Button
                  name={OPTION_NAMES.CUSTOM}
                  onClick={changeSegments}
                  theme={
                    selected === OPTION_NAMES.CUSTOM ? BUTTON_THEME.PRIMARY : BUTTON_THEME.SECONDARY
                  }
                >
                  {`Custom (${audienceObj.custom.length})`}
                </Button>
              </If>
              <If condition={permissions['Branded Audiences']}>
                <Button
                  name={OPTION_NAMES.BRANDED}
                  onClick={changeSegments}
                  theme={
                    selected === OPTION_NAMES.BRANDED
                      ? BUTTON_THEME.PRIMARY
                      : BUTTON_THEME.SECONDARY
                  }
                >
                  {`Branded (${audienceObj.branded.length})`}
                </Button>
              </If>
              <If condition={permissions['White Label Audiences']}>
                <Button
                  name={OPTION_NAMES.WHITE_LABEL}
                  onClick={changeSegments}
                  theme={
                    selected === OPTION_NAMES.WHITE_LABEL
                      ? BUTTON_THEME.PRIMARY
                      : BUTTON_THEME.SECONDARY
                  }
                >
                  {`White Label (${audienceObj.white_label.length})`}
                </Button>
              </If>
            </div>
          </If>

          <Table
            className="search-list__table"
            columns={getTableColumns(selected === 'white_label')}
            data={currAudienceGroup}
            onRowClick={this.onRowClick}
            onSort={this.onSort}
            sort_dir={this.state.sortDir}
            sort_key={this.state.sortKey}
          />
        </If>

        <If condition={audienceObj[selected].length > 0}>
          <Pagination options={audienceGroups} onPageChange={onPageChange} page={page} />
        </If>
      </div>
    )
  }
}

// export
export default SearchListView
